<template lang='pug' src='./our-practice.pug'></template>

<script>
import Doctors from 'components/custom/custom-practice-doctors/custom-practice-doctors'
import Events from 'components/custom/custom-practice-events/custom-practice-events'
import Hero from 'components/hero/hero-pages/hero-pages'
import Loader from 'components/loader/loader'
import OfficeBloomingdale from 'components/custom/custom-practice-office/custom-practice-office-bloomingdale/custom-practice-office-bloomingdale'
import OfficeNaperville from 'components/custom/custom-practice-office/custom-practice-office-naperville/custom-practice-office-naperville'
import OfficeChicago from 'components/custom/custom-practice-office/custom-practice-office-chicago/custom-practice-office-chicago'
import Team from 'components/custom/custom-practice-team/custom-practice-team'
import Directions from 'components/custom/custom-practice-map/custom-practice-map'

export default {
  name: 'our-practice',
  computed: {
    props () {
      return this.$store.state.pages['our-practice']
    },
    loading () {
      return this.$store.state.loading
    }
  },
  components: {
    Doctors,
    Events,
    Hero,
    Loader,
    Directions,
    OfficeBloomingdale,
    OfficeNaperville,
    OfficeChicago,
    Team
  }
}
</script>



// WEBPACK FOOTER //
// our-practice.vue?512810aa